import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const OutlinedWrapperContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",

  border: `1px solid ${colors.gray200}`,
  borderRadius: "12px",
  height: "100%",
  width: "100%",
}));

export const Body = styled("div")(() => ({
  padding: "24px",
}));

export const Footer = styled("footer")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "16px",
  justifyContent: "flex-end",
  borderTop: `1px solid ${colors.gray200}`,
  padding: "16px 24px",
}));
